import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderIssuesAdapter = getAdapter({ idFieldName: 'id' });

const repairOrderIssuesSlice = createSlice({
  name: 'repairOrderIssues',
  initialState: repairOrderIssuesAdapter.getInitialState(),
  reducers: {
    setRepairOrderIssues: (state, { payload: { repairOrderIssues } }) => {
      repairOrderIssuesAdapter.setAll(state, repairOrderIssues);
    },
  },
});

const selectors = repairOrderIssuesAdapter.getSelectors(({ repairOrderIssues }) => repairOrderIssues);

export const getRepairOrderIssues = (state) => selectors.selectAll(state);

export const { setRepairOrderIssues } = repairOrderIssuesSlice.actions;

export default repairOrderIssuesSlice.reducer;
